import { useLayoutEffect, useRef, type ReactNode } from 'react';

import { cx } from '@/shared/lib/cx';
import { t } from '@/shared/i18n';

import styles from './Crumbs.module.scss';

interface Props {
  /**
   * Что открыто сейчас (ключ задачи, slug доски, id страницы). Сменился —
   * полоса прокручивается к концу: активная крошка последняя, и на узком
   * экране видна должна быть она, а не начало пути.
   */
  current: string;
  className?: string | undefined;
  children: ReactNode;
}

/**
 * Хлебные крошки: одна строка без переносов. Не влезли — прокручиваются по
 * горизонтали внутри себя, а не ломают шапку (Давид, 19 сентября 2026).
 * Сами крошки — ссылки и текст — оформляет страница.
 */
export function Crumbs({ current, className, children }: Props) {
  const ref = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    const el = ref.current;
    if (el) {
      el.scrollLeft = el.scrollWidth;
    }
  }, [current]);

  return (
    <nav ref={ref} className={cx(styles['crumbs'], className)} aria-label={t.nav.path}>
      {children}
    </nav>
  );
}
